import React, { Fragment, useState, useEffect } from 'react'
import NavHeader from './NavHeader'
import SideBar from './Sidebar'
import Header from './Header'

const Nav = ({ title, onClick: ClickToAddEvent, onClick2, onClick3 }) => {
  const [toggle, setToggle] = useState('')
  const [checkSizeDevice, setCheckSizeDevice] = useState(false)
  const [showArrowIcon, setShowArrowIcon] = useState(false)

  useEffect(() => {
    if (window.innerWidth <= 767) {
      setCheckSizeDevice(true)
    } else {
      setCheckSizeDevice(false)
    }
  }, [window.innerWidth])

  const onClick = (name) => setToggle(toggle === name ? '' : name)
  return (
    <Fragment>
      <NavHeader showArrowIcon={showArrowIcon} />
      <SideBar checkSizeDevice={checkSizeDevice} setShowArrowIcon={setShowArrowIcon} />
      <Header
        // onNote={() => onClick("chatbox")}
        onNotification={() => onClick('notification')}
        // onProfile={() => onClick("profile")}
        toggle={toggle}
        // title={title}
        onBox={() => onClick('box')}
        // onClick={() => ClickToAddEvent()}
      />
    </Fragment>
  )
}

export default Nav
